import { useState, useEffect } from 'preact/hooks';
import { getProduct, updateProduct } from '../../../api/products';
import PageContent from '../../../components/page-content';
import Heading from '../../../components/heading';
import { Button, Card, Form, Tab, Tabs } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlus, faSave } from '@fortawesome/free-solid-svg-icons';
import { Editor } from '@monaco-editor/react';
import PageLoader from '../../../components/page-loader';
import { useContext } from 'preact/hooks';
import { NotificationContext } from '../../../components/notification-provider';
import FormulaTable from '../../../components/formula-table';
import { route } from 'preact-router';
import { getFormula, getFormulas } from '../../../api/formulas';
import Fields from '../../fields';
import FieldTable from '../../../components/field-table';
import { getFields } from '../../../api/fields';
import { getProductFields } from '../../../api/products';
import { to } from 'react-spring';
import AddProductFieldModal from '../../../components/add-product-field-modal';
import Covers from '../../covers';
import { getProductCovers } from '../../../api/products';
import CoverTable from '../../../components/cover-table';
import ProductCoverTable from '../../../components/product-cover-table';

export default function ProductSave({ id }) {

    const [product, setProduct] = useState(null);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [productFormulasLoading, setProductFormulasLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('general');
    const [productFieldsLoading, setProductFieldsLoading] = useState(false);
    const [productFields, setProductFields] = useState([]);
    const [fields, setFields] = useState([]);
    const [fieldsLoading, setFieldsLoading] = useState(false);
    const [addFieldModalOpen, setAddFieldModalOpen] = useState(false);
    const [covers, setCovers] = useState([]);
    const [coversLoading, setCoversLoading] = useState(true);

    const loadCovers = async () => {
        try {
            setCoversLoading(true);
            const response = await getProductCovers(id);
            const responseData = response.data;
            if (responseData.success === true) {
                const p = responseData.data;
                setCovers(p);
            } else {
                throw new Error(responseData.message);
            }
        } catch (ex) {
            console.log(ex);
            addNotification(ex.message, 'danger');
        } finally {
            setCoversLoading(false);
        }
    }

    const { addNotification } = useContext(NotificationContext);

    const toggleAddFieldModal = () => {
        setAddFieldModalOpen(prevState => !prevState);
    }

    const loadProduct = async () => {
        try {
            setLoading(true);
            const response = await getProduct(id);
            const responseData = response.data;
            if (responseData.success === true) {
                const p = responseData.data;
                setProduct(p);
            } else {
                throw new Error(responseData.message);
            }
        } catch (ex) {
            console.log(ex);
            addNotification(ex.message, 'danger');
        } finally {
            setLoading(false);
        }
    }

    const loadProductFormulas = async () => {
        try {
            setProductFormulasLoading(true);
            const response = await getFormulas(id);
            const responseData = response.data;
            if (responseData.success === true) {
                const p = responseData.data;
                setProduct(prevState => ({
                    ...prevState,
                    formulas: p
                }));
            } else {
                throw new Error(responseData.message);
            }
        } catch (ex) {
            console.log(ex);
            addNotification(ex.message, 'danger');
        } finally {
            setProductFormulasLoading(false);
        }
    }

    const loadProductFields = async () => {
        try {
            setProductFieldsLoading(true);
            const response = await getProductFields(id);
            const responseData = response.data;
            if (responseData.success === true) {
                const p = responseData.data;
                setProductFields(p);
            } else {
                throw new Error(responseData.message);
            }
        } catch (ex) {
            console.log(ex);
            addNotification(ex.message, 'danger');
        } finally {
            setProductFieldsLoading(false);
        }
    }

    const loadFields = async () => {
        try {
            setFieldsLoading(true);
            const response = await getFields();
            const responseData = response.data;
            if (responseData.success === true) {
                const p = responseData.data;
                setFields(p);
            } else {
                throw new Error(responseData.message);
            }
        } catch (ex) {
            console.log(ex);
            addNotification(ex.message, 'danger');
        } finally {
            setFieldsLoading(false);
        }
    }

    const handleMetadataChange = (value, event) => {
        try {
            const md = JSON.parse(value);
            setProduct(prevState => ({
                ...prevState,
                metadata: md
            }));
            // delete errors.metadata key completely
            const { metadata, ...rest } = errors;
            setErrors(rest);
        } catch (ex) {
            console.error(ex);
            setErrors(prevState => ({
                ...prevState,
                metadata: ex.message
            }));
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProduct(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const canSubmit = () => {
        return Object.keys(errors).length === 0 && !loading && !saving;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!canSubmit()) {
            return;
        }

        try {
            setSaving(true);
            const response = await updateProduct(id, product);
            const responseData = response.data;
            if (responseData.success === true) {
                const p = responseData.data;
                setProduct(p);
                addNotification(`Le produit ${p?.name} a été mis à jour`, 'success');
            } else {
                throw new Error(responseData.message);
            }
        } catch (ex) {
            addNotification(ex.message, 'danger');
            console.log(ex);
        } finally {
            setSaving(false);
        }
    }

    const handleTabSelect = (key) => {
        window.localStorage.setItem('product-save-tab', key);

        window.location.hash = key;

        setActiveTab(key);
    }

    const handleNewFormula = () => {
        return route(`/products/${id}/save-formula`);
    }

    useEffect(() => {
        if (id) {
            loadProduct();
            loadProductFields();
            loadFields();
            loadCovers();
        }

       // loadProductFormulas();

        const tab = window.localStorage.getItem('product-save-tab');

        if (tab) {
            handleTabSelect(tab);
        } else {
            let hash = window.location.hash;
            if (hash) {
                handleTabSelect(hash.replace('#', ''));
            }
        }
    }, []);

    useEffect(() => {
        let tab = window.location.hash.replace('#', '');

        if ([...['general', 'metadata', 'formulas', 'fields', 'covers'], ...fields.map(f => f.key)].indexOf(tab) === -1) {
            tab = 'general';
        }

        setActiveTab(tab);
    }, [window.location.hash]);

    if (loading) {
        return <PageLoader message={`Chargement du produit...`} />;
    }

    return <PageContent>

        {/* Add field modal */}
        {addFieldModalOpen && <AddProductFieldModal
            show={addFieldModalOpen}
            onHide={toggleAddFieldModal}
            product={product}
            productKey={id}
            fields={fields}
            onSave={loadProductFields}
        />}

        <Heading>
            <div className="d-flex align-items-center justify-content-between">
                <h2 className="mb-0">
                    {id ? <>Modifier le produit <code>{product?.name}</code></> : `Ajouter un produit`}
                </h2>

                <div className="ms-3 d-flex align-items-center gap-3">

                    {/* Back */}
                    <Button variant="outline-primary" onClick={() => window.history.back()}>
                        <FontAwesomeIcon icon={faArrowLeft} className={`me-2`} />
                        Retour
                    </Button>

                    {/* Nouveau champ */}
                    <Button variant="outline-primary" onClick={toggleAddFieldModal}>
                        <FontAwesomeIcon icon={faPlus} className={`me-2`} />
                        Nouveau champ
                    </Button>

                    {/* Nouvelle formule */}
                    <Button variant="outline-primary" onClick={handleNewFormula}>
                        <FontAwesomeIcon icon={faPlus} className={`me-2`} />
                        Nouvelle formule
                    </Button>

                    <Button variant="primary"  disabled={!canSubmit()} form="product-form" type="submit">
                        <FontAwesomeIcon icon={faSave} className={`me-2`} spin={saving} />
                        Enregistrer
                    </Button>
                </div>
            </div>
        </Heading>

        <Tabs  id="uncontrolled-tab-example" className="mt-4" activeKey={activeTab} onSelect={handleTabSelect}>
            <Tab eventKey="general" title="Général">
                <Card className={`animate__animated animate animate__fadeIn rounded-0`}>

                    <Form className="p-4" onSubmit={handleSubmit} id="product-form">

                        <Form.Group className="mb-3" controlId="name">
                            <Form.Label>Nom</Form.Label>
                            <Form.Control type="text" name="name" value={product?.name} onChange={handleChange} isInvalid={errors.name} />
                            {errors.name ? <div className="mt-2 text-danger">{errors.name}</div> : null}
                        </Form.Group>


                        <Form.Group className="mb-3" controlId="code">
                            <Form.Label>Code</Form.Label>
                            <Form.Control type="text" name="code" value={product?.code} onChange={handleChange} isInvalid={errors.code} />
                            {errors.code ? <div className="mt-2 text-danger">{errors.code}</div> : null}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="type">
                            <Form.Label>Type</Form.Label>
                            <Form.Control type="text" name="type" value={product?.type} onChange={handleChange} isInvalid={errors.type} />
                            {errors.type ? <div className="mt-2 text-danger">{errors.type}</div> : null}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="description">
                            <Form.Label>Description</Form.Label>
                            <Form.Control as="textarea" name="description" value={product?.description} onChange={handleChange} isInvalid={errors.description} />
                            {errors.description ? <div className="mt-2 text-danger">{errors.description}</div> : null}
                        </Form.Group>

                        <Card className={``} as="details">
                            <Card.Header as="summary">
                                Divers
                            </Card.Header>
                            <Card.Body className={`animate__animated animate animate__fadeIn`}>

                                {/* id readonly */}
                                <Form.Group className="mb-3" controlId="id">
                                    <Form.Label>Identifiant</Form.Label>
                                    <Form.Control type="text" name="id" value={product?.id} readOnly />
                                </Form.Group>

                                {/* external_id */}
                                <Form.Group className="mb-3" controlId="external_id">
                                    <Form.Label>Identifiant externe</Form.Label>
                                    <Form.Control type="text" name="external_id" value={product?.external_id} onChange={handleChange} isInvalid={errors.external_id} />
                                    {errors.external_id ? <div className="mt-2 text-danger">{errors.external_id}</div> : null}
                                </Form.Group>

                                {/* Created at */}
                                <Form.Group className="mb-3" controlId="created_at">
                                    <Form.Label>Créé le</Form.Label>
                                    <Form.Control type="text" name="created_at" value={product?.created_at} readOnly />
                                </Form.Group>

                                {/* Updated at */}
                                <Form.Group className="mb-3" controlId="updated_at">
                                    <Form.Label>Modifié le</Form.Label>
                                    <Form.Control type="text" name="updated_at" value={product?.updated_at} readOnly />
                                </Form.Group>

                            </Card.Body>
                        </Card>


                    </Form>

                </Card>
            </Tab>

            <Tab eventKey="metadata" title="Métadonnées">
                <Card>
                    {errors.metadata ? <Card.Header>
                        {errors.metadata ? <div className="mt-2 text-danger">{errors.metadata}</div> : null}
                    </Card.Header> : null}
                    <Card.Body>
                        <Editor
                            height="90vh"
                            defaultLanguage="json"
                            defaultValue={JSON.stringify(product?.metadata, null, 4)}
                            theme="vs-light"
                            onChange={handleMetadataChange}
                        />
                    </Card.Body>
                </Card>

            </Tab>

            {/* Covers */}
            <Tab eventKey="covers" title={`Garanties (${covers?.length ?? 0}) ${coversLoading ? '(Chargement...)' : ''}`}>
                <Card>
                    <Card.Body className='p-0'>
                        {!coversLoading ? <ProductCoverTable product={product} productKey={id} covers={covers} /> : 'Chargement...'}
                    </Card.Body>
                </Card>
            </Tab>

            {/* Formulas */}
            <Tab eventKey="formulas" title={`Formules (${product?.formulas?.length ?? 0}) ${productFormulasLoading ? '(Chargement...)' : ''}`}>
                <Card>
                    <Card.Body className="p-0">
                        <FormulaTable formulas={product?.formulas ?? []} product={product} productKey={id} />
                    </Card.Body>
                </Card>
            </Tab>

            {/* Fields */}
            <Tab eventKey="fields" title={`Champs (${productFields?.length ?? 0}) ${productFieldsLoading ? '(Chargement...)' : ''}`}>
                <Card>
                    <Card.Body className="p-0">
                        <FieldTable fields={productFields} productKey={id} product={product} />
                    </Card.Body>
                </Card>
            </Tab>
        </Tabs>


    </PageContent>

}